<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="国家" prop="country">
                <a-input v-model="queryParam.country" placeholder="请输入国家" allow-clear/>
              </a-form-item>
            </a-col>

            <template >




            </template>

            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>

                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>

              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <create-form-detail :orderId="orderId"
        ref="createFormDetail"

      />
      <!-- 上传文件 -->
      <import-excel ref="importExcel" @ok="getList" />
<!--      </a-drawer>-->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 300px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>

        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['order:order:edit']" />-->
          <a @click="handleInfo(record)" v-hasPermi="['order:order:edit']">
            <a-icon type="file" />查看详情
          </a>

        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getStatistics } from '@/api/order/order'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import CreateFormDetail from '../orderItem/index'
import ImportExcel from './modules/ImportExcel'

export default {
  name: 'OrderOrder',
  components: {
    CreateForm,
    CreateFormDetail,
    ImportExcel
  },
  props:["type"],

  mixins: [tableMixin],
  data () {
    return {
      date:[],
      list: [],
      open:false,
      orderId:null,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        country: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '国家',
          dataIndex: 'country',
          ellipsis: true,
          align: 'center',
          width:180,
          customRender: (text) => {
            if (text === '')
              return "其他";
            else {
              return text
            }
          }
        },
        {
          title: '购买人数',
          dataIndex: 'buyNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单总数',
          dataIndex: 'orderNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单总金额',
          dataIndex: 'orderAmount',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  mounted() {
    this.getList()
  },
  // created () {
  //   this.queryParam.userId = this.$route.query.userId
  //   // if (this.$route.query.types)  {
  //   //    this.queryParam.types = this.$route.query.types.split(',')
  //   // }
  //   this.getList()
  // },
  computed: {
  },
  watch: {
  },
  methods: {
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    /** 查询订单信息列表 */
    getList () {
      this.loading = true

      getStatistics(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },


    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        country: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },

  }
}
</script>
